// PERS2-87: the legacy /transactions endpoint returns a split transaction
// header even when a category filter matched one of its allocations.  The
// analytics pie must therefore project matching allocations on the client.
const categoryName = (categoryId, explicitName, categoryMap) => (
  explicitName || categoryMap[categoryId]?.name || 'Без категории'
);

export const expenseDistribution = (transactions = [], selectedCategoryIds = [], categoryMap = {}) => {
  const selectedIds = new Set(selectedCategoryIds.map(String));
  const hasCategoryFilter = selectedIds.size > 0;
  const grouped = {};

  const add = (id, name, amount) => {
    const label = categoryName(id, name, categoryMap);
    if (!grouped[label]) grouped[label] = { name: label, value: 0 };
    grouped[label].value += Math.abs(Number(amount) || 0);
  };

  transactions.filter((transaction) => transaction.type === 'expense').forEach((transaction) => {
    const splits = Array.isArray(transaction.splits) ? transaction.splits : [];
    if (hasCategoryFilter && splits.length) {
      splits
        .filter((split) => selectedIds.has(String(split.category_id)))
        .forEach((split) => add(split.category_id, split.category_name, split.amount));
      return;
    }

    // Without a filter the established chart semantics stay intact: a split
    // operation is represented by its header and total amount.
    if (!hasCategoryFilter || selectedIds.has(String(transaction.category_id))) {
      add(transaction.category_id, transaction.category_name, transaction.amount);
    }
  });

  return Object.values(grouped);
};
